// extracted by mini-css-extract-plugin
export var activeDot = "_95-c";
export var buttonContainer = "_95-9";
export var channelButton = "_95-a";
export var clickable = "_95-d";
export var content = "_95-0";
export var contentFull = "_95-2";
export var contentThird = "_95-1";
export var contentWrapper = "_95-7";
export var description = "_95-5";
export var heightShort = "_95-f";
export var image = "_95-3";
export var imageContainer = "_95-4";
export var selectButton = "_95-e";
export var spinnerContainer = "_95-b";
export var titleContent = "_95-8";
export var titleWrapper = "_95-6";